"use strict";
const { TokenService } = require("../services/storage.service");
const store = require("../store");
const posthog = require("posthog-js").default;

module.exports = {
	scrollToElementWithOffset(elementId, offset) {
		setTimeout(function () {
			const element = document.querySelector("#" + elementId);
			const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
			window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
		}, 100);
	},

	viewsSelected(key, data) {
		let current = TokenService.getViewsSelected();

		if (typeof data !== "undefined") {
			current[key] = data;

			TokenService.saveViewsSelected(current);
		}

		return typeof current[key] !== "undefined" ? current[key] : null;
	},

	getOS() {
		const userAgent = navigator.userAgent.toLowerCase();

		if (userAgent.includes("mac")) {
			return "macOS";
		} else if (userAgent.includes("win")) {
			return "Windows";
		} else {
			return "Other";
		}
	},

	hash(clearIt) {
		let hash = window.location.hash.replace("#", "");

		if (clearIt) window.location.hash = "";

		if (hash) {
			try {
				let h = JSON.parse(decodeURI(hash));

				return h;
			} catch (err) {
				console.log(hash, err);
				return null;
			}
		}

		return null;
	},

	formatMoney(pence, symbol = "£") {
		const pounds = Math.floor(pence / 100);
		const remainingPence = pence % 100;

		if (remainingPence === 0) {
			return `${symbol}${pounds}`;
		} else {
			return `${symbol}${pounds}.${Math.round(remainingPence).toString().padStart(2, "0")}`;
		}
	},

	formatNumber(n) {
		let am = "K",
			tot = parseFloat((n + "").replace(",", ""));

		if (tot >= 1000000) {
			am = "M";
			tot /= 1000;
		} else if (tot > 1000) {
			tot /= 1000;

			if (parseFloat(tot.toFixed(0)) < parseFloat(tot.toFixed(1))) {
				tot = tot.toFixed(1);
			} else {
				tot = tot.toFixed(0);
			}

			return tot + am;
		} else {
			if ((n + "").length > 5) {
				tot = tot.toFixed(2);
			}
		}

		return tot;
	},

	track(event, data, services) {
		services = Array.isArray(services) ? services : [services];

		services.forEach(function (service) {
			switch (service) {
				case "klaviyo":
					if (typeof window !== "undefined" && typeof window.klaviyo !== "undefined") {
						window.klaviyo.track(event, data);
					}

					break;
			}
		});
	},

	posthogCapture(event, properties = {}) {
		if (module.exports.isDev()) {
			module.exports.console.log("[PostHog]", event, properties || {});
		}
		
		if (!event || typeof posthog === "undefined" || !posthog.capture) return;

		posthog.capture(event, properties || {});
	},

	console: {
		log: (...args) => {
			console.log(...args);
		},
		warn: (...args) => {
			console.warn(...args);
		},
		error: (...args) => {
			console.error(...args);
		},
	},

	dev: {
		console: {
			log: (...args) => {
				if (!module.exports.isDev()) return;

				module.exports.console.log(...args);
			},
			warn: (...args) => {
				if (!module.exports.isDev()) return;

				module.exports.console.warn(...args);
			},
			error: (...args) => {
				if (!module.exports.isDev()) return;

				module.exports.console.error(...args);
			},
		},
	},

	isDev: () => {
		return !["brands.partneruphub.com", "brands-demo.partneruphub.com"].includes(window.location.host);
	},

	isDemo: () => {
		return ["brands-demo.partneruphub.com"].includes(window.location.host);
	},

	isLocal: () => {
		return window.location.host.split(":")[0] === "localhost";
	},

	isAdmin: () => {
		let extra = TokenService.getExtraInfo();

		return extra && extra.access && extra.access === "admin";
	},

	listProjects: (projects, activeOnly, noShared, addSharedPreLabel) => {
		let projectsProcessed = [];

		if (projects) {
			projects.forEach(function (project) {
				if (!!activeOnly && typeof project.active !== "undefined" && !project.active) return;

				if (!!noShared && typeof project.shared !== "undefined" && !!project.shared) return;

				let p = {};

				["name", "_id", "active", "shared"].forEach(function (key) {
					if (typeof project[key] !== "undefined") {
						p[key] = project[key];
						if (key === "name") {
							if (addSharedPreLabel && !!project.shared) p.name = "Shared: " + p.name;
							p.label = p.name;
						}
						if (key === "_id") p.value = project[key];
					}
				});

				projectsProcessed.push(p);
			});
		}

		projectsProcessed.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

		return projectsProcessed;
	},

	checkForUpdates: (ApiService, _this, callbackContinue, callbackFailed, callbackComplete, userInfo) => {
		/*
    Required data
    lastWebhookUpdateCheck: Object
    lastWebhookUpdate: Object
    loadUserCount: Number
    */

		module.exports.dev.console.log("checkForUpdates", _this.lastWebhookUpdateCheck);

		if (Object.keys(_this.lastWebhookUpdateCheck).length > 0) {
			let updated = false,
				webhookInfo = {};

			Object.keys(_this.lastWebhookUpdateCheck).forEach(function (ev) {
				if (updated) return;

				if (typeof _this.lastWebhookUpdate[ev] !== "undefined") {
					let ts = typeof _this.lastWebhookUpdate[ev] === "object" ? _this.lastWebhookUpdate[ev].timestamp : _this.lastWebhookUpdate[ev];

					if (ts !== _this.lastWebhookUpdateCheck[ev].timestamp) {
						updated = 1;
						module.exports.console.log("updated", ev);
					} else if (ts && userInfo && userInfo.timestampNow) {
						let n = new Date(userInfo.timestampNow).getTime() / 1000,
							t = new Date(ts).getTime() / 1000;

						if (n - t < 3) {
							updated = 1;
							module.exports.console.log("updated AS NEW", ev);
						}
					}

					if (updated) {
						updated = _this.lastWebhookUpdateCheck[ev];
						webhookInfo = _this.lastWebhookUpdate[ev];
						webhookInfo.eventType = ev;
					}
				}
			});

			if (updated) {
				_this.lastWebhookUpdateCheck = {};

				_this.updateLoadingText();

				if (typeof updated === "object" && updated.callback) {
					if (typeof updated.callback === "function") {
						updated.callback(webhookInfo, userInfo);
					}

					if (typeof updated.callback === "string") {
						_this[updated.callback](webhookInfo, userInfo);
					}
				} else if (typeof callbackComplete === "function") {
					callbackComplete(userInfo, webhookInfo);
				}
			} else {
				if (_this.loadUserCount < (_this.lastWebhookUpdateCheckCount || 15)) {
					if (typeof callbackContinue === "function") {
						callbackContinue(userInfo);
					}

					setTimeout(function () {
						++_this.loadUserCount;

						module.exports.loadUser(ApiService, _this, null, callbackContinue, callbackFailed, callbackComplete);
					}, 2000);
				} else {
					_this.lastWebhookUpdateCheck = {};

					if (typeof callbackFailed === "function") {
						callbackFailed(userInfo);
					}
				}
			}
		}
	},

	loadUser: (ApiService, _this, callbackInit, callbackContinue, callbackFailed, callbackComplete) => {
		ApiService.get("users")
			.then(function (info) {
				_this.lastWebhookUpdate = typeof info.data.lastWebhookUpdate !== "undefined" ? info.data.lastWebhookUpdate : {};

				if (callbackInit) {
					if (typeof callbackInit === "function") callbackInit(info.data);
				} else {
					module.exports.checkForUpdates(ApiService, _this, callbackContinue, callbackFailed, callbackComplete, info.data);
				}
			})
			.catch(function (err) {
				console.error(err);
			});
	},

	cancelUpdateRegistration: (_this) => {
		_this.lastWebhookUpdateCheck = {};
		if (_this.lastWebhookUpdateCheckCount) _this.lastWebhookUpdateCheckCount = null;
	},

	registerForUpdates: (ApiService, _this, events, callbackBefore, callbackContinue, callbackFailed, callbackComplete) => {
		_this.loadUserCount = 0;
		_this.lastWebhookUpdateCheck = {};

		module.exports.loadUser(
			ApiService,
			_this,
			function (userInfo) {
				events.forEach(function (ev) {
					let ev2 = ev;

					if (typeof ev === "object") {
						ev2 = ev;
					} else {
						ev2 = {
							eventType: ev2,
						};
					}

					ev2.eventType = ev2.eventType.split(".").join("-");

					_this.lastWebhookUpdateCheck[ev2.eventType] = ev2;

					_this.lastWebhookUpdateCheck[ev2.eventType].timestamp = null;

					if (typeof _this.lastWebhookUpdate[ev2.eventType] !== "undefined") {
						_this.lastWebhookUpdateCheck[ev2.eventType].timestamp =
							typeof _this.lastWebhookUpdate[ev2.eventType] === "object"
								? _this.lastWebhookUpdate[ev2.eventType].timestamp
								: _this.lastWebhookUpdate[ev2.eventType];
					}
				});

				if (typeof callbackBefore === "function")
					callbackBefore(function (cancel) {
						if (cancel) {
							module.exports.cancelUpdateRegistration(_this);
						} else {
							module.exports.checkForUpdates(ApiService, _this, callbackContinue, callbackFailed, callbackComplete, userInfo);
						}
					});
			},
			callbackContinue,
			callbackFailed,
			callbackComplete
		);
	},

	getErrorMessage: (msg) => {
		if (typeof msg === "object") {
			if (typeof msg.response !== "undefined" && typeof msg.response.data !== "undefined" && typeof msg.response.data.error !== "undefined") {
				return msg.response.data.error;
			}
		}

		return "";
	},

	globalMessage: (apiResponse) => {
		let r = typeof apiResponse.data !== "undefined" ? apiResponse.data : apiResponse;

		if (r.globalMessage) {
			store.commit("general/printGlobalMessage", r.globalMessage);
		}
	},

	timeFuture: (d, addIn, noTomorrow) => {
		const now = new Date();
		const then = new Date(d);

		const seconds = Math.floor((then.getTime() - now.getTime()) / 1000);
		const minutes = Math.round(seconds / 60);
		const hours = Math.ceil(minutes / 60);
		const days = Math.ceil(hours / 24);

		const s = function (t) {
			return t === 1 ? "" : "s";
		};

		const theIn = addIn ? "in " : "";

		if (seconds < 60) {
			return `${theIn}${seconds} sec${s(seconds)}`;
		} else if (minutes < 60) {
			return `${theIn}${minutes} min${s(minutes)}`;
		} else if (hours < 24) {
			return `${theIn}${hours} hour${s(hours)}`;
		} else if (days === 1 && !noTomorrow) {
			return `Tomorrow`;
		} else {
			return `${theIn}${days} day${s(days)}`;
		}
	},

	timeAgo: (d, dateFormat, timeFormat, dateTimeSameYear) => {
		const now = new Date();
		const then = new Date(d);

		const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);
		const minutes = Math.round(seconds / 60);
		const hours = Math.ceil(minutes / 60);
		const days = Math.ceil(hours / 24);

		const s = function (t) {
			return t === 1 ? "" : "s";
		};

		if (seconds < 60) {
			return `${seconds} sec${s(seconds)} ago`;
		} else if (minutes < 60) {
			return `${minutes} min${s(minutes)} ago`;
		} else if (hours < 24) {
			return `${hours} hour${s(hours)} ago`;
		} else if (days === 1) {
			return `Yesterday at ${module.exports.dateFormat(timeFormat, d)}`;
		} else if (days < 10) {
			return `${days} day${s(days)} ago`;
		} else if (!!dateTimeSameYear && then.getFullYear() === now.getFullYear()) {
			return module.exports.dateFormat(dateTimeSameYear, d);
		} else {
			return module.exports.dateFormat(dateFormat, d);
		}
	},

	dateFormat: (format, date) => {
		if (!date || date === "") {
			date = new Date();
		} else {
			date = new Date(date); // attempt to convert string to date object
		}

		var string = "",
			mo = date.getMonth(), // month (0-11)
			m1 = mo + 1, // month (1-12)
			dow = date.getDay(), // day of week (0-6)
			d = date.getDate(), // day of the month (1-31)
			y = date.getFullYear(), // 1999 or 2003
			h = date.getHours(), // hour (0-23)
			mi = date.getMinutes(), // minute (0-59)
			s = date.getSeconds(); // seconds (0-59)

		for (var i = 0, len = format.length; i < len; i++) {
			switch (format[i]) {
				case "S": // Day of the month without leading zeros  (1 to 31)
					let s = ["th", "st", "nd", "rd"],
						v = d % 100;
					string += s[(v - 20) % 10] || s[v] || s[0];
					break;
				case "j": // Day of the month without leading zeros  (1 to 31)
					string += d;
					break;

				case "d": // Day of the month, 2 digits with leading zeros (01 to 31)
					string += d < 10 ? "0" + d : d;
					break;

				case "l": // (lowercase 'L') A full textual representation of the day of the week
					var days = Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
					string += days[dow];
					break;

				case "w": // Numeric representation of the day of the week (0=Sunday,1=Monday,...6=Saturday)
					string += dow;
					break;

				case "D": // A textual representation of a day, three letters
					days = Array("Sun", "Mon", "Tue", "Wed", "Thr", "Fri", "Sat");
					string += days[dow];
					break;

				case "m": // Numeric representation of a month, with leading zeros (01 to 12)
					string += m1 < 10 ? "0" + m1 : m1;
					break;

				case "n": // Numeric representation of a month, without leading zeros (1 to 12)
					string += m1;
					break;

				case "F": // A full textual representation of a month, such as January or March
					var months = Array(
						"January",
						"February",
						"March",
						"April",
						"May",
						"June",
						"July",
						"August",
						"September",
						"October",
						"November",
						"December"
					);
					string += months[mo];
					break;

				case "M": // A short textual representation of a month, three letters (Jan - Dec)
					months = Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
					string += months[mo];
					break;

				case "Y": // A full numeric representation of a year, 4 digits (1999 OR 2003)
					string += y;
					break;

				case "y": // A two digit representation of a year (99 OR 03)
					string += y.toString().slice(-2);
					break;

				case "H": // 24-hour format of an hour with leading zeros (00 to 23)
					string += h < 10 ? "0" + h : h;
					break;

				case "g": // 12-hour format of an hour without leading zeros (1 to 12)
					var hour = h === 0 ? 12 : h;
					string += hour > 12 ? hour - 12 : hour;
					break;

				case "h": // 12-hour format of an hour with leading zeros (01 to 12)
					hour = h === 0 ? 12 : h;
					hour = hour > 12 ? hour - 12 : hour;
					string += hour < 10 ? "0" + hour : hour;
					break;

				case "a": // Lowercase Ante meridiem and Post meridiem (am or pm)
					string += h < 12 ? "am" : "pm";
					break;

				case "i": // Minutes with leading zeros (00 to 59)
					string += mi < 10 ? "0" + mi : mi;
					break;

				case "s": // Seconds, with leading zeros (00 to 59)
					string += s < 10 ? "0" + s : s;
					break;

				case "c": // ISO 8601 date (eg: 2012-11-20T18:05:54.944Z)
					string += date.toISOString();
					break;

				default:
					string += format[i];
			}
		}

		return string;
	},

	scrollIntoView(id) {
		var headerHeight = document.querySelector(".header .menu .admin-menu .admin-menu-wrap").offsetHeight + 20,
			element = document.getElementById(id);

		element.scrollIntoView(true);

		let scrolledY = window.scrollY;

		if (scrolledY) {
			window.scroll(0, scrolledY - headerHeight);
		}
	},

	modalClose: () => {
		let top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

		setTimeout(function () {
			window.scrollTo(0, top);
		}, 1);
	},

	loginCheck: (ApiService, cb) => {
		let brand = TokenService.getBrand(),
			uri = "users";

		if (!!brand && !isNaN(brand)) uri = "users/check-brand/" + brand;

		ApiService.get(uri)
			.then(function (response) {
				TokenService.saveCheckLogin();
				cb(true, response.data);
			})
			.catch(
				function () {
					cb(false);
				}.bind(this)
			);
	},

	capitalizeFirstLetter: (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},

	apiResponse: (data, callBackWhenOK) => {
		if (typeof data.data.error === "undefined" && typeof data.data.errors === "undefined") {
			callBackWhenOK(data.data);
			return;
		}

		alert(data.data.error);
	},
	stripObject: (object, label) => {
		try {
			return JSON.parse(JSON.stringify(object));
		} catch (err) {
			console.error("stripObject", err, object, label);
		}
	},
	// https://raw.githubusercontent.com/ReactiveSets/toubkal/master/lib/util/value_equals.js
	equalObjects: (a, b, enforce_properties_order, cyclic) => {
		return (
			(a === b && // strick equality should be enough unless zero
				a !== 0) || // because 0 === -0, requires test by _equals()
			_equals(a, b) // handles not strictly equal or zero values
		);

		function _equals(a, b) {
			// a and b have already failed test for strict equality or are zero

			var s, l, p, x, y;

			// They should have the same toString() signature
			if ((s = toString.call(a)) !== toString.call(b)) return false;

			switch (s) {
				default: // Boolean, Date, String
					return a.valueOf() === b.valueOf();

				case "[object Number]":
					// Converts Number instances into primitive values
					// This is required also for NaN test bellow
					a = +a;
					b = +b;

					return a // a is Non-zero and Non-NaN
						? a === b // a is 0, -0 or NaN
						: a === a // a is 0 or -O
							? 1 / a === 1 / b // 1/0 !== 1/-0 because Infinity !== -Infinity
							: b !== b; // NaN, the only Number not equal to itself!
				// [object Number]

				case "[object RegExp]":
					return (
						a.source == b.source &&
						a.global == b.global &&
						a.ignoreCase == b.ignoreCase &&
						a.multiline == b.multiline &&
						a.lastIndex == b.lastIndex
					);
				// [object RegExp]

				case "[object Function]":
					return false; // functions should be strictly equal because of closure context
				// [object Function]

				case "[object Array]":
					if (cyclic && (x = reference_equals(a, b)) !== null) return x; // intentionally duplicated bellow for [object Object]

					if ((l = a.length) != b.length) return false;
					// Both have as many elements

					while (l--) {
						if (((x = a[l]) === (y = b[l]) && x !== 0) || _equals(x, y)) continue;

						return false;
					}

					return true;
				// [object Array]

				case "[object Object]":
					if (cyclic && (x = reference_equals(a, b)) !== null) return x; // intentionally duplicated from above for [object Array]

					l = 0; // counter of own properties

					if (enforce_properties_order) {
						var properties = [];

						for (p in a) {
							if (a.hasOwnProperty(p)) {
								properties.push(p);

								if (((x = a[p]) === (y = b[p]) && x !== 0) || _equals(x, y)) continue;

								return false;
							}
						}

						// Check if 'b' has as the same properties as 'a' in the same order
						for (p in b) if (b.hasOwnProperty(p) && properties[l++] != p) return false;
					} else {
						for (p in a) {
							if (a.hasOwnProperty(p)) {
								++l;

								if (((x = a[p]) === (y = b[p]) && x !== 0) || _equals(x, y)) continue;

								return false;
							}
						}

						// Check if 'b' has as not more own properties than 'a'
						for (p in b) if (b.hasOwnProperty(p) && --l < 0) return false;
					}

					return true;
				// [object Object]
			} // switch toString.call( a )
		} // _equals()

		/* -----------------------------------------------------------------------------------------
       reference_equals( a, b )
       
       Helper function to compare object references on cyclic objects or arrays.
       
       Returns:
       - null if a or b is not part of a cycle, adding them to object_references array
       - true: same cycle found for a and b
       - false: different cycle found for a and b
       
       On the first call of a specific invocation of equal(), replaces self with inner function
       holding object_references array object in closure context.
       
       This allows to create a context only if and when an invocation of equal() compares
       objects or arrays.
    */
		function reference_equals(a, b) {
			var object_references = [];

			return (reference_equals = _reference_equals)(a, b);

			function _reference_equals(a, b) {
				var l = object_references.length;

				while (l--) if (object_references[l--] === b) return object_references[l] === a;

				object_references.push(a, b);

				return null;
			} // _reference_equals()
		} // reference_equals()
	},

	isMobile: () => {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	},
};
